import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Error caught by error boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // A way OUT, not just a message. A render error used to blank the whole
      // app, and inside the Flutter WebView there is no browser chrome to
      // recover with — the only option was to kill the app.
      return (
        <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
          <p className="font-montserrat text-lg font-bold text-[#0F172A]">
            Something went wrong
          </p>
          <p className="mt-1 text-sm text-secondary">
            This screen could not be loaded. Reloading usually fixes it.
          </p>
          <button
            type="button"
            onClick={() => window.location.assign("/feed")}
            className="mt-5 rounded-xl bg-[#0F4146] px-6 py-3 text-sm font-semibold text-white"
          >
            Back to QUSHi
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
